export default "__VITE_ASSET__BuI$$Vuq__"